/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LogType {
    None = 0,
    All = 1,
    Navigation = 2,
    CashPayment = 4,
    CheckPayment = 8,
    CardPayment = 16,
    CustomerInformationSystem = 32,
    PaymentProvider = 64,
    Printer = 128,
    BarCodeScanner = 256,
    CheckScanner = 512,
    CashAcceptor = 1024,
    CardReader = 2048,
    Alerts = 4096,
    Translation = 8192,
    Server = 16384,
}
